/* 🔒 The certificate fact card (T3082; decision 7440): a small bordered box in the tile, the header over a grid of facts over a foot holding the ⋯ menu. Every value a token. */
.card {
  width: 100%;
  min-width: 0;
  padding: var(--space-2) var(--space-3);
  border: 1px solid var(--tile-border);
  border-radius: var(--radius-medium);
  background: var(--surface);
}

.head {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: var(--space-1) var(--space-2);
  padding-bottom: var(--space-1);
  border-bottom: 1px solid var(--surface-2);
}

.badgeSlot {
  display: inline-flex;
}

/* The badge's own start margin spaces it from a name before it; it leads the header here, so it carries none. */
.badgeSlot > [data-tile-badge] {
  margin-inline-start: 0;
}

.title {
  min-width: 0;
  flex: 1 1 auto;
  font-weight: var(--font-weight-bold);
  overflow-wrap: break-word;
}

.pill {
  display: inline-flex;
}

.facts {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(var(--tile-text-column-min-width), 1fr));
  gap: var(--space-2) var(--space-3);
  margin: var(--space-2) 0 0;
}

.fact {
  min-width: 0;
  margin: 0;
}

/* The reason, and who ended the certificate and when, are the longest facts and stand on a line of their own. */
.wide {
  grid-column: 1 / -1;
}

.label {
  color: var(--text-muted);
  font-size: var(--font-size-caption);
  font-weight: var(--font-weight-bold);
  text-transform: uppercase;
}

.value {
  margin: 0;
  font-size: var(--font-size-small);
  overflow-wrap: anywhere;
}

.foot {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: var(--space-2);
  padding-top: var(--space-1);
  border-top: 1px solid var(--surface-2);
}

/* An ended, expired or awaiting-review card fades its words and keeps its pill and its menu. */
.muted {
  color: var(--text-muted);
}

.muted .title {
  font-weight: var(--font-weight-regular);
}
